import { Filter } from '../models/DynamicDataParams';
import { FilterType } from '../models/enums/FilterType';

export const generateEqualFilter = (
  paramName: string,
  paramValue: any,
  type: FilterType = FilterType.EQUALS,
): Filter => ({
  paramName,
  type,
  paramValues: [paramValue],
});